export const FETCH_NAV_ATHLETES_START = 'FETCH_NAV_ATHLETES_START';
export const FETCH_NAV_ATHLETES_FULFILLED = 'FETCH_NAV_ATHLETES_FULFILLED';
export const FETCH_NAV_ATHLETES_REJECTED = 'FETCH_NAV_ATHLETES_REJECTED';

export const FETCH_NAV_ARCHIVED_ATHLETES_START = 'FETCH_NAV_ARCHIVED_ATHLETES_START';
export const FETCH_NAV_ARCHIVED_ATHLETES_FULFILLED = 'FETCH_NAV_ARCHIVED_ATHLETES_FULFILLED';
export const FETCH_NAV_ARCHIVED_ATHLETES_REJECTED = 'FETCH_NAV_ARCHIVED_ATHLETES_REJECTED';

export const FETCH_NAV_ATHLETE_ASSIGNMENTS_START = 'FETCH_NAV_ATHLETE_ASSIGNMENTS_START';
export const FETCH_NAV_ATHLETE_ASSIGNMENTS_FULFILLED = 'FETCH_NAV_ATHLETE_ASSIGNMENTS_FULFILLED';
export const FETCH_NAV_ATHLETE_ASSIGNMENTS_REJECTED = 'FETCH_NAV_ATHLETE_ASSIGNMENTS_REJECTED';

export const FETCH_NAV_ATHLETE_CALENDARS_START = 'FETCH_NAV_ATHLETE_CALENDARS_START';
export const FETCH_NAV_ATHLETE_CALENDARS_FULFILLED = 'FETCH_NAV_ATHLETE_CALENDARS_FULFILLED';
export const FETCH_NAV_ATHLETE_CALENDARS_REJECTED = 'FETCH_NAV_ATHLETE_CALENDARS_REJECTED';

export const DELETE_NAV_ATHLETE_CALENDAR_START = 'DELETE_NAV_ATHLETE_CALENDAR_START';
export const DELETE_NAV_ATHLETE_CALENDAR_FULFILLED = 'DELETE_NAV_ATHLETE_CALENDAR_FULFILLED';
export const DELETE_NAV_ATHLETE_CALENDAR_REJECTED = 'DELETE_NAV_ATHLETE_CALENDAR_REJECTED';

export const FETCH_NAV_ATHLETE_PROGRAMS_START = 'FETCH_NAV_ATHLETE_PROGRAMS_START';
export const FETCH_NAV_ATHLETE_PROGRAMS_FULFILLED = 'FETCH_NAV_ATHLETE_PROGRAMS_FULFILLED';
export const FETCH_NAV_ATHLETE_PROGRAMS_REJECTED = 'FETCH_NAV_ATHLETE_PROGRAMS_REJECTED';

export const ASSIGN_NAV_ATHLETE_PROGRAMS_START = 'ASSIGN_NAV_ATHLETE_PROGRAMS_START';
export const ASSIGN_NAV_ATHLETE_PROGRAMS_FULFILLED = 'ASSIGN_NAV_ATHLETE_PROGRAMS_FULFILLED';
export const ASSIGN_NAV_ATHLETE_PROGRAMS_REJECTED = 'ASSIGN_NAV_ATHLETE_PROGRAMS_REJECTED';

export const DELETE_NAV_ATHLETE_PROGRAM_START = 'DELETE_NAV_ATHLETE_PROGRAM_START';
export const DELETE_NAV_ATHLETE_PROGRAM_FULFILLED = 'DELETE_NAV_ATHLETE_PROGRAM_FULFILLED';
export const DELETE_NAV_ATHLETE_PROGRAM_REJECTED = 'DELETE_NAV_ATHLETE_PROGRAM_REJECTED';

export const RESTART_NAV_ATHLETE_PROGRAM_START = 'RESTART_NAV_ATHLETE_PROGRAM_START';
export const RESTART_NAV_ATHLETE_PROGRAM_FULFILLED = 'RESTART_NAV_ATHLETE_PROGRAM_FULFILLED';
export const RESTART_NAV_ATHLETE_PROGRAM_REJECTED = 'RESTART_NAV_ATHLETE_PROGRAM_REJECTED';

export const FETCH_NAV_CALENDARS_START = 'FETCH_NAV_CALENDARS_START';
export const FETCH_NAV_CALENDARS_FULFILLED = 'FETCH_NAV_CALENDARS_FULFILLED';
export const FETCH_NAV_CALENDARS_REJECTED = 'FETCH_NAV_CALENDARS_REJECTED';

export const FETCH_NAV_CALENDAR_ITEMS_START = 'FETCH_NAV_CALENDAR_ITEMS_START';
export const FETCH_NAV_CALENDAR_ITEMS_FULFILLED = 'FETCH_NAV_CALENDAR_ITEMS_FULFILLED';
export const FETCH_NAV_CALENDAR_ITEMS_REJECTED = 'FETCH_NAV_CALENDAR_ITEMS_REJECTED';

export const FETCH_NAV_CALENDAR_PREVIEW_START = 'FETCH_NAV_CALENDAR_PREVIEW_START';
export const FETCH_NAV_CALENDAR_PREVIEW_FULFILLED = 'FETCH_NAV_CALENDAR_PREVIEW_FULFILLED';
export const FETCH_NAV_CALENDAR_PREVIEW_REJECTED = 'FETCH_NAV_CALENDAR_PREVIEW_REJECTED';

export const FETCH_NAV_GROUPS_START = 'FETCH_NAV_GROUPS_START';
export const FETCH_NAV_GROUPS_FULFILLED = 'FETCH_NAV_GROUPS_FULFILLED';
export const FETCH_NAV_GROUPS_REJECTED = 'FETCH_NAV_GROUPS_REJECTED';

export const CREATE_NAV_GROUP_START = 'CREATE_NAV_GROUP_START';
export const CREATE_NAV_GROUP_FULFILLED = 'CREATE_NAV_GROUP_FULFILLED';
export const CREATE_NAV_GROUP_REJECTED = 'CREATE_NAV_GROUP_REJECTED';

export const FETCH_NAV_GROUP_START = 'FETCH_NAV_GROUP_START';
export const FETCH_NAV_GROUP_FULFILLED = 'FETCH_NAV_GROUP_FULFILLED';
export const FETCH_NAV_GROUP_REJECTED = 'FETCH_NAV_GROUP_REJECTED';

export const UPDATE_NAV_GROUP_START = 'UPDATE_NAV_GROUP_START';
export const UPDATE_NAV_GROUP_FULFILLED = 'UPDATE_NAV_GROUP_FULFILLED';
export const UPDATE_NAV_GROUP_REJECTED = 'UPDATE_NAV_GROUP_REJECTED';

export const FETCH_NAV_PROGRAMS_START = 'FETCH_NAV_PROGRAMS_START';
export const FETCH_NAV_PROGRAMS_FULFILLED = 'FETCH_NAV_PROGRAMS_FULFILLED';
export const FETCH_NAV_PROGRAMS_REJECTED = 'FETCH_NAV_PROGRAMS_REJECTED';

export const FETCH_NAV_PROGRAM_ITEMS_START = 'FETCH_NAV_PROGRAM_ITEMS_START';
export const FETCH_NAV_PROGRAM_ITEMS_FULFILLED = 'FETCH_NAV_PROGRAM_ITEMS_FULFILLED';
export const FETCH_NAV_PROGRAM_ITEMS_REJECTED = 'FETCH_NAV_PROGRAM_ITEMS_REJECTED';

export const FETCH_NAV_PROGRAM_DAY_ONE_START = 'FETCH_NAV_PROGRAM_DAY_ONE_START';
export const FETCH_NAV_PROGRAM_DAY_ONE_FULFILLED = 'FETCH_NAV_PROGRAM_DAY_ONE_FULFILLED';
export const FETCH_NAV_PROGRAM_DAY_ONE_REJECTED = 'FETCH_NAV_PROGRAM_DAY_ONE_REJECTED';

export const FETCH_NAV_PROGRAM_PREVIEW_START = 'FETCH_NAV_PROGRAM_PREVIEW_START';
export const FETCH_NAV_PROGRAM_PREVIEW_FULFILLED = 'FETCH_NAV_PROGRAM_PREVIEW_FULFILLED';
export const FETCH_NAV_PROGRAM_PREVIEW_REJECTED = 'FETCH_NAV_PROGRAM_PREVIEW_REJECTED';

export const FETCH_NAV_USER_START = 'FETCH_NAV_USER_START';
export const FETCH_NAV_USER_FULFILLED = 'FETCH_NAV_USER_FULFILLED';
export const FETCH_NAV_USER_REJECTED = 'FETCH_NAV_USER_REJECTED';

export const UPDATE_NAV_USER_START = 'UPDATE_NAV_USER_START';
export const UPDATE_NAV_USER_FULFILLED = 'UPDATE_NAV_USER_FULFILLED';
export const UPDATE_NAV_USER_REJECTED = 'UPDATE_NAV_USER_REJECTED';

export const UPDATE_NAV_ATHLETE_IMAGE_START = 'UPDATE_NAV_ATHLETE_IMAGE_START';
export const UPDATE_NAV_ATHLETE_IMAGE_FULFILLED = 'UPDATE_NAV_ATHLETE_IMAGE_FULFILLED';
export const UPDATE_NAV_ATHLETE_IMAGE_REJECTED = 'UPDATE_NAV_ATHLETE_IMAGE_REJECTED';

export const REMOVE_NAV_ATHLETE_IMAGE_START = 'REMOVE_NAV_ATHLETE_IMAGE_START';
export const REMOVE_NAV_ATHLETE_IMAGE_FULFILLED = 'REMOVE_NAV_ATHLETE_IMAGE_FULFILLED';
export const REMOVE_NAV_ATHLETE_IMAGE_REJECTED = 'REMOVE_NAV_ATHLETE_IMAGE_REJECTED';

export const CREATE_NAV_USER_START = 'CREATE_NAV_USER_START';
export const CREATE_NAV_USER_FULFILLED = 'CREATE_NAV_USER_FULFILLED';
export const CREATE_NAV_USER_REJECTED = 'CREATE_NAV_USER_REJECTED';

export const DELETE_NAV_USERS_START = 'DELETE_NAV_USERS_START';
export const DELETE_NAV_USERS_FULFILLED = 'DELETE_NAV_USERS_FULFILLED';
export const DELETE_NAV_USERS_REJECTED = 'DELETE_NAV_USERS_REJECTED';

export const DELETE_NAV_GROUPS_START = 'DELETE_NAV_GROUPS_START';
export const DELETE_NAV_GROUPS_FULFILLED = 'DELETE_NAV_GROUPS_FULFILLED';
export const DELETE_NAV_GROUPS_REJECTED = 'DELETE_NAV_GROUPS_REJECTED';

export const RESEND_NAV_ACTIVATION_EMAIL_START = 'RESEND_NAV_ACTIVATION_EMAIL_START';
export const RESEND_NAV_ACTIVATION_EMAIL_FULFILLED = 'RESEND_NAV_ACTIVATION_EMAIL_FULFILLED';
export const RESEND_NAV_ACTIVATION_EMAIL_REJECTED = 'RESEND_NAV_ACTIVATION_EMAIL_REJECTED';

export const ARCHIVE_NAV_USER_START = 'ARCHIVE_NAV_USER_START';
export const ARCHIVE_NAV_USER_FULFILLED = 'ARCHIVE_NAV_USER_FULFILLED';
export const ARCHIVE_NAV_USER_REJECTED = 'ARCHIVE_NAV_USER_REJECTED';

export const UNARCHIVE_NAV_USER_START = 'UNARCHIVE_NAV_USER_START';
export const UNARCHIVE_NAV_USER_FULFILLED = 'UNARCHIVE_NAV_USER_FULFILLED';
export const UNARCHIVE_NAV_USER_REJECTED = 'UNARCHIVE_NAV_USER_REJECTED';

export const FETCH_NAV_WORKOUT_RESULTS_START = 'FETCH_NAV_WORKOUT_RESULTS_START';
export const FETCH_NAV_WORKOUT_RESULTS_FULFILLED = 'FETCH_NAV_WORKOUT_RESULTS_FULFILLED';
export const FETCH_NAV_WORKOUT_RESULTS_REJECTED = 'FETCH_NAV_WORKOUT_RESULTS_REJECTED';

export const FETCH_NAV_DAY_WORKOUT_ITEMS_START = 'FETCH_NAV_DAY_WORKOUT_ITEMS_START';
export const FETCH_NAV_DAY_WORKOUT_ITEMS_FULFILLED = 'FETCH_NAV_DAY_WORKOUT_ITEMS_FULFILLED';
export const FETCH_NAV_DAY_WORKOUT_ITEMS_REJECTED = 'FETCH_NAV_DAY_WORKOUT_ITEMS_REJECTED';

export const SET_IS_PREVIEW_CAROUSEL_SHOWING = 'SET_IS_PREVIEW_CAROUSEL_SHOWING';

export const BULK_UPDATE_GROUPS_START = 'BULK_UPDATE_GROUPS_START';
export const BULK_UPDATE_GROUPS_FULFILLED = 'BULK_UPDATE_GROUPS_FULFILLED';
export const BULK_UPDATE_GROUPS_REJECTED = 'BULK_UPDATE_GROUPS_REJECTED';

export const BULK_UPDATE_CALENDARS_START = 'BULK_UPDATE_CALENDARS_START';
export const BULK_UPDATE_CALENDARS_FULFILLED = 'BULK_UPDATE_CALENDARS_FULFILLED';
export const BULK_UPDATE_CALENDARS_REJECTED = 'BULK_UPDATE_CALENDARS_REJECTED';

export const UPLOAD_NAV_USERS_START = 'UPLOAD_NAV_USERS_START';
export const UPLOAD_NAV_USERS_FULFILLED = 'UPLOAD_NAV_USERS_FULFILLED';
export const UPLOAD_NAV_USERS_REJECTED = 'UPLOAD_NAV_USERS_REJECTED';

export const FETCH_NAV_COACHES_START = 'FETCH_NAV_COACHES_START';
export const FETCH_NAV_COACHES_FULFILLED = 'FETCH_NAV_COACHES_FULFILLED';
export const FETCH_NAV_COACHES_REJECTED = 'FETCH_NAV_COACHES_REJECTED';

export const FETCH_NAV_BLACKOUT_DATES_START = 'FETCH_NAV_BLACKOUT_DATES_START';
export const FETCH_NAV_BLACKOUT_DATES_FULFILLED = 'FETCH_NAV_BLACKOUT_DATES_FULFILLED';
export const FETCH_NAV_BLACKOUT_DATES_REJECTED = 'FETCH_NAV_BLACKOUT_DATES_REJECTED';

export const CREATE_NAV_BLACKOUT_DATE_START = 'CREATE_NAV_BLACKOUT_DATE_START';
export const CREATE_NAV_BLACKOUT_DATE_FULFILLED = 'CREATE_NAV_BLACKOUT_DATE_FULFILLED';
export const CREATE_NAV_BLACKOUT_DATE_REJECTED = 'CREATE_NAV_BLACKOUT_DATE_REJECTED';

export const DELETE_NAV_BLACKOUT_DATES_START = 'DELETE_NAV_BLACKOUT_DATES_START';
export const DELETE_NAV_BLACKOUT_DATES_FULFILLED = 'DELETE_NAV_BLACKOUT_DATES_FULFILLED';
export const DELETE_NAV_BLACKOUT_DATES_REJECTED = 'DELETE_NAV_BLACKOUT_DATES_REJECTED';
